(() => {
  const locale=document.documentElement.lang;
  const originalLocalize=value=>locale.startsWith('zh')?value.replace(/Daily /gi,'每日 ').replace(/Total /gi,'总量 ').replace(/Unlimited /gi,'无限 ').replace(/ DAYS?/gi,' 天'):locale==='th'?value.replace(/Daily /gi,'รายวัน ').replace(/Total /gi,'ดาต้ารวม ').replace(/Unlimited /gi,'ไม่จำกัด ').replace(/ DAYS?/gi,' วัน'):value;
  const newWords = {ja:['毎日 ','合計 ','無制限 ',' 日'], 'zh-TW':['每日 ','總量 ','無限 ',' 天'],ko:['매일 ','총량 ','무제한 ',' 일'],es:['Diario ','Total ','Ilimitados ',' días']}[locale];
  const localize = value => newWords ? value.replace(/Daily /gi,newWords[0]).replace(/Total /gi,newWords[1]).replace(/Unlimited /gi,newWords[2]).replace(/ DAYS?/gi,newWords[3]) : originalLocalize(value);
  function labels(root=document){
    root.querySelectorAll('variant-selects select option').forEach(o=>{o.textContent=localize(o.textContent);});
    root.querySelectorAll('.rd-selected-name').forEach(e=>{e.textContent=localize(e.textContent);});
  }
  labels();
  function guidePage(root, page, focus=false){
    root.querySelectorAll('[data-guide-tab]').forEach(tab=>{
      const active=tab.dataset.guideTab===page;
      tab.setAttribute('aria-selected',String(active));tab.tabIndex=active?0:-1;
      if(active && focus)tab.focus();
    });
    root.querySelectorAll('[data-guide-panel]').forEach(panel=>{panel.hidden=panel.dataset.guidePanel!==page;});
  }
  document.addEventListener('click',event=>{
    const tab=event.target.closest('[data-guide-tab]');
    if(tab)guidePage(tab.closest('[data-rd-guide]'),tab.dataset.guideTab);
  });
  document.addEventListener('keydown',event=>{
    const tab=event.target.closest('[data-guide-tab]');
    if(!tab || !['ArrowRight','ArrowLeft','Home','End'].includes(event.key))return;
    event.preventDefault();const root=tab.closest('[data-rd-guide]'),tabs=[...root.querySelectorAll('[data-guide-tab]')];
    const index=event.key==='Home'?0:event.key==='End'?tabs.length-1:(tabs.indexOf(tab)+(event.key==='ArrowRight'?1:-1)+tabs.length)%tabs.length;
    guidePage(root,tabs[index].dataset.guideTab,true);
  });
  // Delegate touch handling so it survives Shopify variant panel replacements.
  let swipe=null;
  document.addEventListener('touchstart',event=>{
    swipe=null;
    if(event.touches.length!==1 || !matchMedia('(max-width: 749px)').matches)return;
    const panel=event.target.closest('[data-guide-panel]');
    if(!panel || event.target.closest('a,button,input,select,textarea,[contenteditable="true"],[data-country-finder]'))return;
    const point=event.touches[0];
    swipe={root:panel.closest('[data-rd-guide]'),x:point.clientX,y:point.clientY,id:point.identifier};
  },{passive:true});
  document.addEventListener('touchmove',event=>{
    if(!swipe)return;
    const point=event.touches[0];
    if(event.touches.length!==1 || point.identifier!==swipe.id){swipe=null;return;}
    const dx=Math.abs(point.clientX-swipe.x),dy=Math.abs(point.clientY-swipe.y);
    if(dy>16 && dy>dx)swipe=null;
  },{passive:true});
  document.addEventListener('touchcancel',()=>{swipe=null;},{passive:true});
  document.addEventListener('touchend',event=>{
    const gesture=swipe;swipe=null;
    if(!gesture || !gesture.root.isConnected || event.touches.length)return;
    const point=[...event.changedTouches].find(t=>t.identifier===gesture.id);
    if(!point)return;
    const dx=point.clientX-gesture.x,dy=point.clientY-gesture.y;
    if(Math.abs(dx)<60 || Math.abs(dx)<Math.abs(dy)*1.5)return;
    const tabs=[...gesture.root.querySelectorAll('[data-guide-tab]')];
    const index=tabs.findIndex(t=>t.getAttribute('aria-selected')==='true');
    const next=index+(dx<0?1:-1);
    if(index>=0 && next>=0 && next<tabs.length)guidePage(gesture.root,tabs[next].dataset.guideTab);
  },{passive:true});
  document.addEventListener('input',event=>{
    if(!event.target.matches('[data-country-search]'))return;
    const panel=event.target.closest('[data-country-finder]');
    const query=event.target.value.trim().normalize('NFKC').toLocaleLowerCase();
    let matches=0;
    panel.querySelectorAll('[data-country-name]').forEach(item=>{
      item.hidden=!(item.dataset.countryName + ' ' + item.textContent).normalize('NFKC').toLocaleLowerCase().includes(query);
      if(!item.hidden)matches++;
    });
    panel.querySelector('[data-country-empty]').hidden=matches>0;
  });
  document.addEventListener('change',event=>{
    if(!event.target.closest('variant-selects'))return;
    const guide=document.querySelector('[data-rd-guide]');
    if(guide){guide.setAttribute('aria-busy','true');guide.querySelectorAll('.rd-guide-sheet').forEach(sheet=>{sheet.style.visibility='hidden';});}
    const target=document.querySelector('[data-rd-selected]');
    if(target){
      target.textContent=({ja:'このプランで選択できる利用日数をお選びください。','zh-TW':'請選擇此方案支援的使用天數。',ko:'이 요금제에서 지원하는 이용 기간을 선택하세요.',es:'Elige una duración disponible para este plan.'}[locale]) || (locale.startsWith('zh')?'请核对并选择此套餐支持的天数。':locale==='th'?'โปรดเลือกจำนวนวันที่แพ็กเกจนี้รองรับ':'Please choose a duration supported by this plan.');
    }
  },true);
  if(typeof subscribe==='function' && typeof PUB_SUB_EVENTS!=='undefined'){
    subscribe(PUB_SUB_EVENTS.variantChange,event=>{
      const id='RdSelected-'+event.data.sectionId;
      const target=document.getElementById(id),source=event.data.html.getElementById(id);
      if(target && source){target.replaceWith(source.cloneNode(true));labels();}
      const guideId='RdGuide-'+event.data.sectionId,guide=document.getElementById(guideId),next=event.data.html.getElementById(guideId);
      if(guide && next){
        const selected=guide.querySelector('[aria-selected=true]')?.dataset.guideTab || 'cover';
        const replacement=next.cloneNode(true);guide.replaceWith(replacement);guidePage(replacement,selected);
      }
    });
  }
  // The native Shopify product form, cart and localization remain authoritative.
  document.querySelectorAll('[data-at-locale]').forEach(select=>select.addEventListener('change',()=>select.form.requestSubmit()));
})();
